import cn from 'classnames';
import { memo } from 'react';

import { Popup } from 'shared/components/Popup';
import { withTranslation } from 'shared/helpers/i18n.helpers';

import { IconGeekMode, IconLightMode } from './icons';
import styles from './styles.module.scss';
import { Logo } from '../Logo';

interface Props {
  className?: string;
  isChecked: boolean;
  onToggle: () => void;
}

const HeaderWithMode = ({ className, isChecked, onToggle }: Props) => (
  <div className={cn(styles.wrapper, className)}>
    <Logo />
    <Popup
      content={withTranslation('Light or KOL mode')}
      position="bottom right"
      trigger={(
        <div className={styles.toggleWrap}>
          <button onClick={onToggle} className={cn(styles.switcher, { [styles.active]: isChecked })}>
            {IconLightMode}
            <div className={styles.dot} />
            {IconGeekMode}
          </button>
        </div>
      )}
    />
  </div>
);

export default memo(HeaderWithMode);
